/**
 * Root Imports
*/

import { ApiRequest } from '~/util/Api';

/**
 * Locals
*/

const endpoint = '/api/v1/permissions';

/**
 * Exports
*/

/**
 * 
 */
export function IndexPermissionService() {
  const config = {
    method: 'GET',
    uri: endpoint
  };

  return ApiRequest(config);
}